import { render, staticRenderFns } from "./PageAllLeaveSummary.vue?vue&type=template&id=1287f743"
import script from "./PageAllLeaveSummary.vue?vue&type=script&lang=js"
export * from "./PageAllLeaveSummary.vue?vue&type=script&lang=js"
import style0 from "./PageAllLeaveSummary.vue?vue&type=style&index=0&id=1287f743&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports